import { useInitialization } from 'hooks/useInitialization';

export const Initializer = () => {
  useInitialization();

  return <></>;
};
